/** @format */

const externalLinks = {
  vomozFlexLandingPage: "https://vomozflex.com/",
  vomozFlexLandingPagePrivacyPolicy:
    "https://vomozflex.com/terms-and-conditions",
  vomozGroupLandingPageSMSPrivacyPolicy:
    "https://vomozflex.com/sms-terms-and-privacy-policy",
  vomozFlexAppJoin: "https://app.vomozflex.com/join",
  vomozFlexAppLogin: "https://app.vomozflex.com/login",
  vomozFlexResetPassword: "https://app.vomozflex.com/reset-password/",
  vomozFlexAndroidApp:
    "https://play.google.com/store/apps/details?id=com.vomoz.systems.apps.android",
  vomozFlexIosApp:
    "https://apps.apple.com/us/app/vomoz-communications/id960996015",
  vomozGroupLandingPage: "https://vomozgroup.com",
  testingSiteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", // Google's test key
}

export default externalLinks
